import { createReducer, on } from "@ngrx/store";
import { CatalogueStateModel } from '@signature-it/ngx-catalogue/store/models';
import { CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';

declare let _: any;


export const catalogueInitialState = new CatalogueStateModel();
export const catalogueReducer = createReducer(
    catalogueInitialState,
    on(CatalogueActions.getProductPrice, (state) => ({ ...state, ...{
            loadingPriceList: true,
        }})),
    on(CatalogueActions.gotProductPriceSuccess, (state, {prices}) => ({ ...state, ...{
            priceList: state.priceList ? state.priceList.concat(prices).reduce((a, b) => !a.filter(c => b['id'] === c['id']).length ? [...a, b] : a, []): prices,
            loadingPriceList: false
        }})),
    on(CatalogueActions.gotProductPriceFailure, (state) => ({ ...state, ...{
            loadingPriceList: false
        }})),
    on(CatalogueActions.getProductsStock, (state) => (state)),
    on(CatalogueActions.gotProductsStockSuccess, (state, {stock}) => ({ ...state, ...{
            stockList: stock
        }})),
    on(CatalogueActions.gotProductsStockFailure, (state) => (state)),
    on(CatalogueActions.getGroupUserLinks, (state, {payload}) => ({ ...state, ...{
            loadingUserLinks: true
        }})),
    on(CatalogueActions.gotGroupUserLinksSuccess, (state, {payload}) => ({ ...state, ...{
            loadingUserLinks: false,
            groupUserLinksFields: state.groupUserLinksFields ? state.groupUserLinksFields.concat(payload).reduce((a, b) =>
                !a.filter(c => b['id'] === c['id'] && b['taxonomy'] === c['taxonomy'] && b['entityVar'] === c['entityVar']).length ? [...a, b] : a, []
            ) : payload
        }})),
    on(CatalogueActions.gotGroupUserLinksFailure, (state) => ({ ...state, ...{
            loadingUserLinks: false,
        }})),
    on(CatalogueActions.getGroupsTree, (state) => ({ ...state, ...{
            loadingGroupsTree: true,
        }})),
    on(CatalogueActions.gotGroupsTreeSuccess, (state, {payload}) => ({ ...state, ...{
            groupsTree: payload,
            loadingGroupsTree: false,
        }})),
    on(CatalogueActions.gotGroupsTreeFailure, (state) => ({ ...state, ...{
            loadingGroupsTree: false,
        }})),
    on(CatalogueActions.getCurrentGroup, (state) => (state)),
    on(CatalogueActions.gotCurrentGroupSuccess, (state, {payload}) => ({ ...state, ...{
            currentGroup: payload
        }})),
    on(CatalogueActions.gotCurrentGroupFailure, (state) => ({ ...state, ...{
            currentGroup: null
        }})),
    on(CatalogueActions.getProductSolrDoc, (state) => ({ ...state, ...{
            loadingProductSolrDoc: true
        }})),
    on(CatalogueActions.gotProductSolrDocSuccess, (state, payload) => ({ ...state, ...{
            productSolrDoc: payload,
            loadingProductSolrDoc: false
        }})),
    on(CatalogueActions.gotProductSolrDocSuccess, (state) => ({ ...state, ...{
            gotProductSolrDocFailure: false
        }})),
    on(CatalogueActions.getFavorites, (state) => (state)),
    on(CatalogueActions.getFavoritesSuccess, (state, {payload}) => ({ ...state, ...{
            favoritesList: payload,
            favoritesIds: payload.map(f => parseInt(f.productId)),
            loadingFavoritesList: false
        }})),
    on(CatalogueActions.getFavoritesFailure, (state) => ({ ...state, ...{
            loadingFavoritesList: false
        }})),
    on(CatalogueActions.addFavorite, (state, payload) => ({ ...state, ...{
            updatedFavoritesSuccess: false,
            processingAddToFavorites: true
        }})),
    on(CatalogueActions.addFavoriteSuccess, (state, payload) => ({ ...state, ...{
            favoritesIds: [...state.favoritesIds || [], payload['productId']],
            updatedFavoritesSuccess: true,
            processingAddToFavorites: false
        }})),
    on(CatalogueActions.removeFavorite, (state) => ({ ...state, ...{
            removeFavoritesSuccess: false
        }})),
    on(CatalogueActions.removeFavoriteSuccess, (state, payload) => {
        const id = payload['productIds'][0];
        return { ...state, ...{
                favoritesList: state.favoritesList.filter((fDTO) => fDTO.productId !== id.toString()),
                favoritesIds: state.favoritesIds.filter((favorite) => favorite !== id),
                removeFavoritesSuccess: true
            }}} ),
)

